import sideMenu from "../layout/sidenav/sidenav.menu";

let AuthService = (
  Restangular,
  Toast,
  $filter,
  $localStorage,
  $mdDialog,
  $rootScope,
  $sessionStorage,
  $state,
  $transitions
) => {
  function init() {
    $transitions.onStart({}, (transition) => {
      return authenticate(transition.to()).catch((redirect) => {
        return $state.target(redirect);
      });
    });
  }

  function forbidAccess(reject) {
    $mdDialog.show(
      $mdDialog
        .alert()
        .clickOutsideToClose(true)
        .title($filter("translate")("auth-service-forbid-access-dialog-title"))
        .textContent(
          $filter("translate")("auth-service-forbid-access-dialog-text")
        )
        .ariaLabel(
          $filter("translate")("auth-service-forbid-access-dialog-text")
        )
        .ok($filter("translate")("common-ok"))
    );
    logout();
    reject("login");
  }

  function authenticate(target) {
    let isPublicTarget = _.get(target, "data.public");

    return new Promise((resolve, reject) => {
      if (isPublicTarget && !isAuthenticated()) {
        resolve();
        return;
      } else if (!isPublicTarget && !isAuthenticated()) {
        reject("login");
        return;
      }

      Restangular.service("admin/me")
        .one()
        .get()
        .then((me) => {
          if (me.access_group) {
            $rootScope.user = me;
            if (target.name === "login") {
              reject("unit.list");
            } else {
              resolve();
            }
          } else {
            forbidAccess(reject);
          }
        })
        .catch((err) => {
          forbidAccess(reject);
        });
    });
  }

  function getAuthorizedModules(accessGroup) {
    let modules = accessGroup.admin_modules;

    if (!accessGroup || accessGroup.deleted_at || _.isEmpty(modules)) {
      return false;
    }

    let authorizedModules = _.map(modules, (module) => {
      return module.name;
    });

    return authorizedModules;
  }

  function getAuthorizedStates(accessGroup) {
    let modules = accessGroup.admin_modules;

    if (!accessGroup || accessGroup.deleted_at || _.isEmpty(modules)) {
      return false;
    }

    let authorizedStates = [];

    _.forEach(modules, (module) => {
      let found = _.find(sideMenu, { title: module.name });
      let subMenu = found.subMenu;

      if (subMenu) {
        _.forEach(subMenu, (item) => {
          authorizedStates = authorizedStates.concat(item.children);
        });
      } else {
        authorizedStates = authorizedStates.concat(found.children);
      }
    });

    return authorizedStates;
  }

  function login(token, user, rememberMe) {
    if (rememberMe) {
      $localStorage.token = token;
    } else {
      $sessionStorage.token = token;
    }
  }

  function logout() {
    $localStorage.$reset();
    localStorage.clear()
    $sessionStorage.$reset();
    sessionStorage.clear()
    $state.go("login");
  }

  function isAuthenticated() {
    return $localStorage.token || $sessionStorage.token;
  }

  function isAuthorized(targetState, accessGroup) {
    if (accessGroup.is_super || targetState === "me") {
      return true;
    }

    let authorizedStates = getAuthorizedStates(accessGroup);
    return authorizedStates.indexOf(targetState) > -1;
  }

  return { getAuthorizedModules, init, isAuthenticated, login, logout };
};

AuthService.$inject = [
  "Restangular",
  "Toast",
  "$filter",
  "$localStorage",
  "$mdDialog",
  "$rootScope",
  "$sessionStorage",
  "$state",
  "$transitions",
];

export default AuthService;



// WEBPACK FOOTER //
// ./client/app/common/services/auth.service.js